export default "__VITE_ASSET__2856c6af__"